// Victory progress, the unit tray, and the end-of-match banner / summary.
// Extracted from App.tsx (ROADMAP 7.14); renders in the same DOM position.

import type { SceneNode } from '@aod/protocol';
import type { ComponentProps } from 'react';
import type { SimWorld } from '../sim/useSimWorld/index.js';
import type { Selection } from '../testBridge/useTestBridge.js';
import { PostVictorySummary } from '../ui/PostVictorySummary.js';
import { UnitSelectionTray } from '../ui/UnitSelectionTray.js';
import { VictoryBanner } from '../ui/VictoryBanner.js';
import { VictoryProgressHUD } from '../ui/VictoryProgressHUD.js';

type VictoryBannerProps = ComponentProps<typeof VictoryBanner>;

interface MatchVictoryLayerProps {
  sim: SimWorld;
  localPlayerIndex: number;
  selected: SceneNode | null;
  selection: Selection;
  unitNodes: ReadonlyArray<SceneNode>;
  showPostGameSummary: boolean;
  finalePlaying: boolean;
  playedPreset: VictoryBannerProps['playedPreset'];
  onSelectUnit: (id: string) => void;
  onNewMatch: () => void;
  onReturnToMenu: () => void;
  onViewSummary: () => void;
  onCloseSummary: () => void;
  onTryPreset: NonNullable<VictoryBannerProps['onTryPreset']>;
}

export function MatchVictoryLayer({
  sim,
  localPlayerIndex,
  selected,
  selection,
  unitNodes,
  showPostGameSummary,
  finalePlaying,
  playedPreset,
  onSelectUnit,
  onNewMatch,
  onReturnToMenu,
  onViewSummary,
  onCloseSummary,
  onTryPreset,
}: MatchVictoryLayerProps) {
  return (
    <>
      {sim.victoryProgress && (
        <VictoryProgressHUD
          victoryProgress={sim.victoryProgress}
          localPlayerIndex={localPlayerIndex}
        />
      )}
      {selected && selection?.kind === 'unit' && (
        <UnitSelectionTray
          selected={selected}
          allUnits={unitNodes}
          localPlayerIndex={localPlayerIndex}
          onSelectUnit={onSelectUnit}
        />
      )}
      {sim.victory && !showPostGameSummary && !finalePlaying && (
        <VictoryBanner
          winner={sim.victory.winner}
          path={sim.victory.path}
          localPlayerIndex={localPlayerIndex}
          onNewMatch={onNewMatch}
          onReturnToMenu={onReturnToMenu}
          onViewSummary={onViewSummary}
          playedPreset={playedPreset}
          onTryPreset={onTryPreset}
        />
      )}
      {sim.victory && showPostGameSummary && sim.snapshot && !finalePlaying && (
        <PostVictorySummary
          snapshot={sim.snapshot}
          winner={sim.victory.winner}
          path={sim.victory.path}
          localPlayerIndex={localPlayerIndex}
          onNewMatch={() => {
            onCloseSummary();
            onNewMatch();
          }}
          onReturnToMenu={() => {
            onCloseSummary();
            onReturnToMenu();
          }}
        />
      )}
    </>
  );
}
